import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Dominica: Country = {
    identifier: "Dominica",
    name: "Dominica",
    countryCode: "DM",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: true,
    flag: "🇩🇲",
    svgPath: "m 302.90875,419.8944 -0.263,0.063 -0.113,-0.499 -0.184,-0.363 0.032,-0.226 0.033,-0.086 0.387,0.139 0.121,0.169 0.073,0.444 z",
}
